module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17DSyDf/tc-custom/9783958641976.jpg?1704761740538",
      "alt": "This image is the cover for the book Yankeedoodle-Fahrt, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Yankeedoodle-Fahrt, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Otto Julius Bierbaum (* 28. Juni 1865 in Grünberg in Schlesien; † 1. Februar 1910 in Dresden), auch bekannt unter den Pseudonymen Martin Möbius und Simplicissimus, war ein deutscher Journalist, Redakteur, Schriftsteller und Librettist. 1902 unternimmt Otto Julius Bierbaum gemeinsam mit seiner Gattin eine Autoreise von Berlin nach Italien und wird damit in zweifacher Hinsicht zum Pionier. Erstens gilt er als der erste Deutsche, der Italien mit einem Automobil bereist und dabei die Alpen überquert hat; zweitens schildert er 1903 diese Autorundfahrt in seiner Empfindsamen Reise im Automobil von Berlin nach Sorrent und zeichnet zugleich ein zeitgenössisches, für die damalige Zeit modernes Italienbild, weit abseits von Goethes ästhetischer Italienreise. Im Zuge seiner Reisen zieht es den Autor und Reisejournalisten in den folgenden Jahren immer wieder nach Südtirol. Biografische Bedeutung für Bierbaum hat Schloss Englar in Eppan: Hier lebt er für einige Jahre und ist literarisch äußerst produktiv. (Auszug aus Wikipedia)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Otto Julius Bierbaum\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Otto Julius Bierbaum (* 28. Juni 1865 in Grünberg in Schlesien; † 1. Februar 1910 in Dresden, auch bekannt unter den Pseudonymen Martin Möbius und Simplicissimus, war ein deutscher Journalist, Redakteur, Schriftsteller und Librettist. (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB Ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0